<template>
    <div v-if="authInfo.region.id">
        <div v-if="authInfo.viewer === anonymousViewer" class="flex flex-col lg:flex-row lg:items-center">
            <label class="mb-2 block text-xs font-medium text-slate-700 lg:hidden">Регион</label>
            <div class="select-region-wrapper select-region-wrapper--ghost relative inline-flex items-center gap-1.5">
                <PhMapPin :size="18" :weight="'regular'" class="shrink-0 text-slate-700" aria-hidden="true" />
                <div class="relative">
                    <label for="region-select" class="sr-only">Регион</label>
                    <span ref="measureText" class="select-region-measure select-region-measure--ghost" :aria-hidden="true">{{ currentRegionText }}</span>
                    <select
                        id="region-select"
                        name="region"
                        v-model="region"
                        class="select-region-ghost focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
                        aria-label="Выбрать регион"
                        :style="selectStyle"
                        @change="relogin()"
                    >
                        <option v-for="item in regions" :key="item.name" :value="item.id">
                            {{ formatRegionName(item.name) }}
                        </option>
                    </select>
                    <PhCaretDown
                        :size="14"
                        :weight="'bold'"
                        class="pointer-events-none absolute right-0 top-1/2 z-10 -translate-y-1/2 text-slate-600"
                        aria-hidden="true"
                    />
                </div>
            </div>
        </div>
        <div v-else class="inline-flex items-center gap-1.5 text-sm font-medium text-slate-900">
            <PhMapPin :size="18" :weight="'regular'" class="shrink-0 text-slate-700" aria-hidden="true" />
            <span>{{ formatRegionName(authInfo.region.name) }}</span>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { useAuth } from '@/store/useAuth'
import { PhMapPin, PhCaretDown } from '@phosphor-icons/vue'
import { formatRegionName } from '@/utils/regionUtils'
import { ANONYMOUS_VIEWER } from '@/constants'

export default {
    components: {
        PhMapPin,
        PhCaretDown
    },
    setup() {
        const authInfo = useAuth()

        return { authInfo }
    },
    apollo: {
        regions: gql`query {
            regions {
                id
                name
            }
        }`
    },
    data() {
        return {
            region: this.authInfo.region.id,
            regions: [],
            selectWidth: null
        }
    },
    computed: {
        anonymousViewer() {
            return ANONYMOUS_VIEWER
        },
        currentRegionText() {
            if (!this.regions || !Array.isArray(this.regions) || this.regions.length === 0) return ''
            const selectedRegion = this.regions.find((item) => item.id === this.region)
            if (!selectedRegion) return ''
            return this.formatRegionName(selectedRegion.name)
        },
        selectStyle() {
            if (!this.selectWidth) return { width: 'auto' }
            return { width: `${this.selectWidth}px`, minWidth: `${this.selectWidth}px` }
        }
    },
    watch: {
        region() {
            this.updateSelectWidth()
        },
        currentRegionText() {
            this.updateSelectWidth()
        },
        regions: {
            handler(newRegions) {
                if (Array.isArray(newRegions) && newRegions.length > 0) {
                    this.updateSelectWidth()
                }
            },
            deep: true
        }
    },
    created() {
        this.authInfo.getViewer()
    },
    updated() {
        if (!this.region) {
            this.region = this.authInfo.region.id
        }
        this.updateSelectWidth()
    },
    mounted() {
        this.updateSelectWidth()
    },
    methods: {
        relogin() {
            this.authInfo.logInGuest(this.region)
        },
        formatRegionName,
        updateSelectWidth() {
            if (!this.currentRegionText) {
                this.selectWidth = null
                return
            }
            this.$nextTick(() => {
                const measureElement = this.$refs.measureText
                if (!measureElement) return

                const textWidth = measureElement.offsetWidth || measureElement.scrollWidth
                if (textWidth === 0) {
                    setTimeout(() => this.updateSelectWidth(), 10)
                    return
                }

                this.selectWidth = textWidth + 18
            })
        }
    }
}
</script>
